<template>
  <el-select
      fit-input-width
      :placeholder="placeholder"
      no-match-text="Topilmadi"
      no-data-text="Ma'lumot yo'q"
      clearable
      filterable
      remote
      remote-show-suffix
      :remote-method="onSearch"
      style="width: 100%"
      v-model="value"
      @focus="handleFocus"
      @blur="handleBlur"
      @change="handleChange"
      size="large"
      :loading="!options.length && loading"
  >
    <el-option v-for="item in options" :key="item.id" :label="item.title"
               :value="item.id"></el-option>
    <el-option v-show="hasNextPage" disabled :value="'loading'">
      <span ref="lastOption">Yuklanmoqda...</span>
    </el-option>
  </el-select>
</template>

<script>
import {ElNotification} from "element-plus";

export default {
  name: "RemoteSearchSelect",
  props: {
    placeholder: {
      type: String,
      default: "Tanlang"
    },
    url: {
      type: String,
      required: true
    },
    params: {
      type: Object
    },
    responseDataField: {
      type: String,
      required: true,
    },
    modelValue: {
      required: true
    }
  },
  computed: {
    hasNextPage() {
      return this.totalCount > this.options.length
    },
  },
  data() {
    return {
      value: 1,
      loading: false,
      options: [],

      observerEl: null,
      search: '',

      page: 1,
      totalCount: 0,
      limit: 10,

      loadingOrg: false
    }
  },
  methods: {
    handleChange() {
      this.$emit('update:modelValue', this.value)
    },
    getOptions() {
      this.loading = true
      this.$http.get(this.url, {
        params: {
          ...this.params,
          search: this.search,
          limit: this.limit,
          offset: this.limit * (this.page - 1),
        }
      }).then(({data}) => {
        this.options.push(...data[this.responseDataField])
        this.totalCount = data.count
        if (this.modelValue) {
          this.value = this.modelValue
        }
      }).catch(({response}) => {
        ElNotification.error({
          message: response.data.message || "Ma'lmumot yuklasda xatolik sodir bo'ldi!"
        })
      }).finally(() => {
        this.loading = false
      })
    },
    onSearch(query) {
      if (query.length >= 2) {
        this.totalCount = 0;
        this.search = query;
        setTimeout(() => {
          this.options = [];
          this.page = 1;
          this.getOptions();
        }, 200)
      } else {
        this.search = "";
        this.options = [];
        this.page = 1;
        this.totalCount = 0;
        this.getOptions()
      }
    },
    handleFocus() {
      this.$nextTick(() => {
        this.observerEl.observe(this.$refs.lastOption)
      });
    },
    handleBlur() {
      this.observerEl.disconnect()
    },
    async infiniteScrollEl([{isIntersecting}]) {
      if (isIntersecting && !this.loading) {
        this.page += 1;
        await this.getOptions();
      }
    },
  },
  mounted() {
    this.observerEl = new IntersectionObserver(this.infiniteScrollEl)
    this.getOptions();
  }

}
</script>

<style scoped>

</style>